import { userActions } from "./users/actions";
import { externalUserActions } from "./externalusers/actions";
import { generalActions } from "./general/actions";
import { invoiceProjectActions } from "./invoice-projects/actions";
import { bookingSettingsActions } from "./booking/actions";
import { accountingSettingsActions } from "./accounting/actions";
import { billingSettingsActions } from "./billing/actions";
import { labelSettingsActions } from "./label/actions";
import { custom_textsSettingsActions } from "./custom_texts/actions";
import { noticesSettingsActions } from "./notices/actions";
import { languageSettingsActions } from "./language/actions";
import { sharingSettingsActions } from "./sharing/actions"
import { promotionSettingsActions} from "./promotion/actions"
import * as types from './types';
import { taskService } from "../../tasks/services/tasks.service";
import { BookingSettingsService } from "../services/booking-settings.service";
import { taskSettingsActions } from "./task/actions";
export const actions = {
  ...userActions,
  ...generalActions,
  ...invoiceProjectActions,
  ...bookingSettingsActions,
  ...accountingSettingsActions,
  ...billingSettingsActions,
  ...labelSettingsActions,
  ...custom_textsSettingsActions,
  ...noticesSettingsActions,
  ...languageSettingsActions,
  ...sharingSettingsActions,
  ...promotionSettingsActions,
  ...externalUserActions,
  ...taskSettingsActions,

  async [types.TaskTemplateGroupItems.DELETE.SINGLE]({ commit,dispatch, getters }, payload) {
    const { task_group_id, task_template_id,external_table,settingsKey } = payload;

    commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
      data:{
        ...getters['taskSettingsData'],
        [`${this.externalTable}_task_templates_of_group_loading`]:true
      }

    });

    const taskTemplatesRes = await BookingSettingsService.removeTaskFromTaskTemplateGroup({ task_group_id, task_template_id });
    // dispatch(types.TaskTemplateGroup.FETCH.ALL, task_group_id);

    const res = await taskService.getTaskTemplatesOfGroup(task_group_id,external_table)
    console.log("OIUYT",res)
   // dispatch(types.TaskSettingsData.SET.ALL,{external_table,settingsKey});
   commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
      data:{
        ...getters['taskSettingsData'],
        ...res.data,
        [`${this.externalTable}_task_templates_of_group_loading`]:false
      }

    });

  },

  async [types.TaskTemplateGroupItems.SET.ALL]({  commit,dispatch, getters }, payload) {
    
    const {settingsKey ,external_table,task_group_id} =payload

    commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
      data:{
        ...getters['taskSettingsData'],
        [`${this.externalTable}_task_templates_of_group_loading`]:true
      }

    });
    
    const res = await taskService.getTaskTemplatesOfGroup(task_group_id,external_table)
    console.log("OIUYT",res)
   // dispatch(types.TaskSettingsData.SET.ALL,{external_table,settingsKey});
   commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
      data:{
        ...getters['taskSettingsData'],
        ...res.data,
        [`${this.externalTable}_task_templates_of_group_loading`]:false
      }

    });
  },

  async [types.TaskTemplate.INSERT.SINGLE]({ dispatch }, payload) {
    
    const {task_template,settingsKey } =payload

    console.log("payload",payload)

    const { external_table,json_data } = task_template
    delete task_template.json_data;
    await taskService.addUpdateTaskTemplate(task_template,json_data)
    dispatch(types.TaskSettingsData.SET.ALL,{external_table,settingsKey});
  },

  async [types.TaskTemplate.DELETE.SINGLE]({ dispatch }, payload) {
    
    const {task_template_id,settingsKey,external_table } =payload

    console.log("payload",payload)

    await taskService.taskTemplateDelete(task_template_id)
    dispatch(types.TaskSettingsData.SET.ALL,{external_table,settingsKey});
  },

  async [types.TaskTemplateGroup.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const { settingsKey,external_table } = payload
    //const taskTemplatesRes = await BookingSettingsService.addUpdateBookingTaskTemplateGroup({task_group_name:payload});
    
    dispatch(types.TaskSettingsData.SET.ALL,payload);    
    // commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
    //   data:{
    //     ...getters[settingsKey],
    //     ...res.data
    //   }

    // });
  },
  async [types.TaskTemplateGroup.DELETE.SINGLE]({ commit,dispatch, getters }, payload) {
    const { task_group_id ,settingsKey,external_table} = payload;

    //getters.bookingSettingsData.task_template_groups.filter(i => i.task_group_id != task_group_id)

    const templateGetterKey=`${external_table}_task_template_groups`
    //const getterSettings =getters[settingsKey]

    console.log({ task_group_id ,settingsKey,external_table},"{ task_group_id ,settingsKey,external_table}")

    commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
      data:{
        ...getters['taskSettingsData'],
        templateGetterKey:getters['taskSettingsData'][templateGetterKey].filter(i => i.task_group_id != task_group_id)
      }

    });
     const taskTemplatesRes = await taskService.deleteBookingTaskTemplateGroup(task_group_id);
     dispatch(types.TaskSettingsData.SET.ALL,payload);    
  },

  async [types.TaskSettingsData.SET.ALL]({ commit, getters, dispatch }, payload) {
    const { settingsKey,external_table } = payload
    //const taskTemplatesRes = await BookingSettingsService.addUpdateBookingTaskTemplateGroup({task_group_name:payload});
    const res = await taskService.taskTemplateGroup(external_table)
    console.log(res,settingsKey,"resSetkey")
    commit(types.TaskSettingsData.SET.ALL, {settingsKey:settingsKey,
      data:{
        ...getters['taskSettingsData'],
        ...res.data
      }

    });
  },
};
